import React from 'react';
import Container from './container';

// require() b/c typescript compiler ignores css import statement
require('./base.css');

interface Props {
    children?: React.ReactNode | readonly React.ReactNode[];
}

const Layout: React.FC<Props> = ({ children }) => {
    return (
        <>
            <a href="#main-content" className="sr-only focusable">
                Skip to main content
            </a>
            <Container>{children}</Container>
        </>
    );
};

export default Layout;
